/**
 * @internal
 */
export const zExecutionDone = Promise.resolve();
//# sourceMappingURL=exec-done.impl.js.map